// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Parece que você se perdeu!',
  text: 'O endereço ou recurso que você procura não existe. Talvez até já tenha existido, mas foi movido ou desativado.',
  btn: {
    text: 'Que tal voltar à Home Page?',
    title: 'Clique aqui para voltar à Home Page',
  },
} as ILanguage;
